import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import Select from "react-select";
import {
  loading,
  tokens,
  select_style,
  total,
  alert,
  alert_url,
  toFixed,
  GET,
  POST,
  PUT,
  format_date,
  float,
  validate,
  required,
  DatePicker,
  NumberZero,
  getStorage,
  roundToTwo,
  fieldSorter,
  calculate_water,
} from "../../components/CustomComponent.js";
import React, { Component } from "react";
import Resizer from "react-image-file-resizer";
import { Modal } from "react-bootstrap";

const role = getStorage("role_detail");
const select_role = role?.find((item) => item.name === "record-receipt");
const view_r = select_role?.role[0] === 1;
const create_r = select_role?.role[1] === 1;

const PAYMENT_TITLES = {
  water_bill: "ค่าใช้น้ำประจำเดือน",
  equipment_maintenance_fee: "ค่ารักษาอุปกรณ์การใช้น้ำ",
  common_expenses: "ค่าใช้จ่ายส่วนกลาง",
  fire_cost: "ค่าเบี้ยประกัน",
  waste_cost: "ค่าบริการจัดเก็บขยะ",
  cable_cost: "ค่าบริการเคเบิล",
  other_income: "ค่าใช้จ่ายอื่นๆ",
  add_debt: "รายการเพิ่มหนี้",
  reduce_debt: "รายการลดหนี้",
  meter_connect_cost: "ค่าต่อกลับมิเตอร์",
  late_payment: "ค่าปรับชำระล่าช้า",
};

const INITIAL_PAYMENT_LIST = Object.keys(PAYMENT_TITLES).map((key) => ({
  title: key,
  cost: 0.0,
  status_pay: false,
}));

// ช่องนี้จบแล้วหรือยัง (เก็บเงินแล้ว/ตัดหนี้แล้ว)
// NOTE s_* ระดับงวดเป็นสถานะรวมของใบ เชื่อรายช่องไม่ได้ — backend ตั้งเป็น true ให้อัตโนมัติเมื่อ cost ของช่องนั้นเป็น 0
// ตอนออกใบเสร็จ (record_receipt/views.py "True if c_xxx == 0 or s_xxx == True") ทั้งที่ยังไม่ได้เก็บเงินจริง
// ยึด transaction_payments/writeoff_list เป็นหลักเสมอ ไม่ fallback ไป item[sKey]
// เพราะหลังยกเลิกการตัดหนี้/ยกเลิกใบเสร็จ backend ไม่ได้ล้าง s_* ระดับงวด ช่องที่กลับมาค้างจะหายจากหน้าเก็บเงิน
const isSettled = (item, sKey) =>
  [item.transaction_payments, item.writeoff_list].some((list) => list?.some((p) => p[sKey]));

export default class RecordReciept extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disable_button: false,
      modal_pay: false,
      modal_clement: false,
      modal_some_pay: false,
      modal_permission: false,
      editable: false,
      page: 1,
      search: "",
      data: null,
      data_customer: null,
      username: "",
      password: "",
      photo: "",
      is_upload_slip: false,
      address_text: "",
      customer_id: "",
      record_water_list: [],
      record_water_list_change: [],
      record_date: new Date(),
      record_time:
        NumberZero(new Date().getHours()) +
        ":" +
        NumberZero(new Date().getMinutes()),
      address_number: "",
      iw_number: "",
      payment_type: 1,
      transfer_date: "",
      transfer_time: "",
      full_name: "",
      project_name: "",
      address: "",
      sum_unit_used: 0,
      payment_list: JSON.parse(JSON.stringify(INITIAL_PAYMENT_LIST)),
      record_other_list: [],
      clement_remark: "",
      total_amount: 0.0,
      change_satang: 0.0,
      total_final: 0.0,
      add_on_add_debt: 0,
      add_on_reduce_debt: 0,
      add_on_add_debt_remark: "",
      add_on_reduce_debt_remark: "",
      total_pay: 0.0,
      remark: "",
      full_name_print: "",
      position_name: "",
      size: 8.5,
      page1: 0,
      page2: -15,
      page3: 25,
      page4: 0,
      ref_customer_id: "",

      setting_water_id: getStorage("water_id"),
      water_charge_start: 0,
      water_charge_end: 0,
      water_charge_price: 0,
      water_rate_list: [],
      payment_deadline: 0,
      common_expenses_text: 0,
      record_water_id: "",
      last_gauge_number: 0,
      current_gauge_number: 0,
      unit_used: 0,
      water_bill: 0,
      equipment_maintenance_fee: 0,
      common_expenses: 0,
      common_expenses_type: false,
      penalty_day_list: [],
      penalty_month_list: [],
      waste_cost: 0,
      cable_cost: 0,
      other_income: 0,
      add_debt: 0,
      reduce_debt: 0,
      fire_month: "",
      fire_cost: 0,
      remark_add_debt: "",
      remark_reduce_debt: "",
      status_cable: false,
      room_size: 0,
      status_meter: 0,
      date_of_note: new Date(),
    };
  }

  async componentDidMount() {
    // this.Print("IW003469050032");
    if (view_r) {
      await Promise.all([
        this.GetSetting(),
        this.GetRunningNumber(),
        this.GetCustomerAll(),
      ])
      if (this.props.location.query.address_number)
        await this.GetByAddressNumber(this.props.location.query.address_number);
    }
  }

  // GET
  GetCustomerAll = async () => {
    let result = await GET(
      tokens,
      `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`,
      { data_search: "", transfer_date: "", status_transfer: "" },
    );
    if (result?.status)
      this.setState({
        data_customer: result.data.data.map((item) => ({
          value: item.address_number,
          label: `อาคาร ${item.building} ห้อง ${item.address_number}`,
        })),
      });
  };

  GetRunningNumber = async () => {
    let result = await GET(
      tokens,
      `v1/TH/record-receipt/running-iw/${getStorage("project_id")}`,
      { format_doc: "IW" },
    );
    if (result?.status) {
      this.setState({ iw_number: result.data.data });
      // คืนเลขตรงๆ ให้ผู้เรียกใช้ทันที (ไม่พึ่ง this.state ที่ setState ยังไม่ทันอัปเดต)
      return result.data.data;
    }
    return null;
  };

  // เลขที่ใบเสร็จจริงจาก response (backend อาจออกเลขใหม่ให้ถ้าเลขที่ส่งไปชน) · ไม่มีมา = ใช้เลขที่ส่งไป
  pickIwNumber = (result, sent) => {
    const d = result?.data;
    const n = (d && typeof d === "object" ? d.iw_number : null) || result?.iw_number;
    return n ? String(n) : sent;
  };

  GetByAddressNumber = async (address_number) => {
    this.setState({ address_number });
    let result = await GET(
      tokens,
      `v1/TH/record-receipt/by-address/${getStorage("project_id")}`,
      { address_number },
    );

    if (result?.status) {
      this.setState({ editable: false });
      let resData = result.data.data;

      const costKeys = [
        { k: "water_bill", sk: "s_water_bill", m: 1 },
        { k: "waste_cost", sk: "s_waste_cost", m: 1 },
        { k: "reduce_debt", sk: "s_reduce_debt", m: -1 },
        { k: "other_income", sk: "s_other_income", m: 1 },
        { k: "meter_connect_cost", sk: "s_meter_connect_cost", m: 1 },
        {
          k: "total_cost_late",
          sk: "s_late_payment",
          m: 1,
          pk: "late_payment",
        },
        {
          k: "equipment_maintenance_fee",
          sk: "s_equipment_maintenance_fee",
          m: 1,
        },
        { k: "common_expenses", sk: "s_common_expenses", m: 1 },
        { k: "cable_cost", sk: "s_cable_cost", m: 1 },
        { k: "add_debt", sk: "s_add_debt", m: 1 },
        { k: "fire_cost", sk: "s_fire_cost", m: 1 },
      ];

      resData.forEach((d) => {
        [
          "total_cost_late",
          "common_expenses",
          "cable_cost",
          "fire_cost",
        ].forEach((k) => (d[k] = Number(String(d[k] || 0).replace(/,/g, ""))));
        d.total_amount = costKeys.reduce((sum, { k, sk, m, pk }) => {
          return (
            sum +
            (isSettled(d, sk) ||
            d.payment_list?.find((e) => e.title === (pk || k) && e.status_pay)
              ? 0
              : (d[k] || 0) * m)
          );
        }, 0);
      });

      if (resData.length) {
        resData.forEach((d) => (d.status = true));
        let check_index = Math.max(
          0,
          this.state.record_water_list_change.findIndex((item) => item.checked),
        );
        const initialPaymentList = Object.keys(PAYMENT_TITLES).map((key) => {
          const isLate = key === "late_payment";
          const costKey = isLate ? "total_cost_late" : key;
          const sKey = isLate ? "s_late_payment" : `s_${key}`;
          return {
            title: key,
            status_pay: true,
            cost:
              total(
                resData.filter(
                  (e) =>
                    !isSettled(e, sKey) &&
                    (!e.payment_list?.length ||
                      e.payment_list.some(
                        (p) => p.title === key && !p.status_pay,
                      )),
                ),
                costKey,
              ) * (key === "reduce_debt" ? -1 : 1),
          };
        });

        this.setState({
          ref_customer_id: resData[0].ref_customer_id,
          customer_id: resData[resData.length - 1].customer_id,
          full_name: resData[check_index].full_name,
          project_name: getStorage("project_name"),
          address:
            resData[resData.length - 1].address ||
            resData[resData.length - 1].address_number,
          address_text:
            resData[resData.length - 1].address ||
            resData[resData.length - 1].address_number,
          record_water_list: resData,
          clement_remark: "",
          total_amount: Number(total(resData, "total_amount").toFixed(2)),
          change_satang: 0.0,
          total_final: Number(total(resData, "total_amount").toFixed(2)),
          sum_unit_used: Number(total(resData, "unit_used").toFixed(2)),
          payment_list: initialPaymentList,
        });
      } else {
        alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
        this.clear_form();
      }
    }
  };

  GetSetting = async () => {
    loading(true);
    let result = await GET(
      tokens,
      `v1/TH/water-manage/detail/${this.state.setting_water_id}`,
      null,
    );
    if (result?.status) {
      let d = result.data.data;
      let date_of_note = d.payment_deadline
        ? new Date(new Date().setDate(Number(d.payment_deadline)))
        : new Date();
      if (d.payment_deadline && new Date() < date_of_note)
        date_of_note.setMonth(date_of_note.getMonth() - 1);

      this.setState({
        ...d,
        water_charge_start: Number(d.water_charge.water_charge_start),
        water_charge_end: Number(d.water_charge.water_charge_end),
        water_charge_price: toFixed(Number(d.water_charge.water_charge_price)),
        fire_cost:
          d.fire_month && format_date(new Date(), "m") === d.fire_month
            ? Number(d.fire_cost)
            : 0,
        common_expenses_text: d.common_expenses,
        date_of_note,
      });

      if (
        !d.payment_close_time ||
        !d.meter_cut_date ||
        !d.penalty_day_list.length ||
        !d.penalty_month_list.length
      ) {
        alert_url(
          "warning",
          "แจ้งเตือน",
          "ท่านยังไม่ทำการตั้งค่าอัตราค่าน้ำก่อนทำการเริ่มต้นใช้งานระบบ",
          "/manage-water",
        );
      }
    }
    loading(false);
  };

  Print = async (iw_number) => {
    loading(true);
      this.setState({ delete_remark: "" });
      try{
            const array_cost = [ "add_debt", "cable_cost", "common_expenses", "equipment_maintenance_fee", "fire_cost", "late_payment", "meter_connect_cost", "other_income", "reduce_debt", "waste_cost", "water_bill" ];
            let result = await GET(tokens, "v1/TH/record-receipt/history/by-iw-number/" + getStorage("project_id"), { iw_number });
            if (result?.status) {
              let data = result.data.data;
  
              console.log("data:", data);
              const baseHeader = {
                project_name: getStorage("project_name"),
                project_address: `เลขที่ ${getStorage("project_address")}\nเบอร์โทรติดต่อ  ${getStorage("phone_number")} เลขที่ผู้เสียภาษี ${getStorage("tax_number")}`,
                cutomer_name: data.full_name,
                cutomer_address: data.address || data.address_number,
                number: data.iw_number,
                date: format_date(data.record_date, "dd mmmm yyyy"),
                payment: data.payment_type === 1 ? "เงินสด" : "โอนเงินเข้าบัญชีนิติฯ",
                payment_date: `${format_date(data.transfer_date || data.record_date, "dd/mm/yyyy")} เวลา ${(data.transfer_time || data.record_time)?.slice(0, 5)}`
              };
      
              if (data?.record_other_list.length !== 0) {
                // ใบเสร็จอื่นๆ
                localStorage.setItem("DATA_", JSON.stringify({
                  ...baseHeader, 
                  title: data.record_other_list?.[0]?.title, 
                  description: data.record_other_list?.[0]?.description,
                  cost: data.record_other_list?.[0]?.cost, 
                  total: data.record_other_list?.[0]?.cost, 
                  change_satang: 0,
                }));
                window.open("/doc/receipt-other", "_blank");
              } else {
                // ใบเสร็จน้ำ
                data.transaction_payments = data.transaction_payments.sort(fieldSorter(["water_current_month"]));
                const getP = (type) => {
                  return data.transaction_payments[0][`s_${type}`] ? data.transaction_payments[0][type == "late_payment" ? "total_cost_late" : type] : 0
                }
                const getT = (item) => {
                  let past_total = 0;
                  array_cost.map(type => {
                    if(type === "reduce_debt"){
                      past_total -= total(item.filter(e=>e[`s_${type}`]), type);
                    }else if(type === "late_payment"){
                      past_total += total(item.filter(e=>e[`s_${type}`]), 'total_cost_late');
                    }else {
                      past_total += total(item.filter(e=>e[`s_${type}`]),type);
                    }
                  })
                  return parseFloat(past_total.toFixed(2));;
                }
                const water_list_price = getT(data.transaction_payments.filter((e,i) => i !== 0)); //ค่าใช้จ่าย เดือนก่อนหน้า
                const total_calc = water_list_price + getT(data.transaction_payments.filter((e,i) => i === 0)) + data.add_on_add_debt - data.add_on_reduce_debt; //รวมทั้งสิ้น
        
                console.log("water_list_price:",water_list_price)
                console.log("total_calc:",total_calc)
        
                const lastMonth = new Date(data.last_date);
                lastMonth.setMonth(lastMonth.getMonth() - 1);
        
                let data_print = {
                  ...baseHeader,
                  water_current_month: data.last_date,
                  water_last_month: data.brefore_last_date !== data.last_date ? data.brefore_last_date : format_date(lastMonth, "yyyy-mm-dd", "en"),
                  last_gauge_number: data.last_gauge_number,
                  current_gauge_number: data.current_gauge_number,
                  unit_used: data.unit_used,
                  water_bill: getP("water_bill"),
                  equipment_maintenance_fee: getP("equipment_maintenance_fee"),
                  waste_cost: getP("waste_cost"),
                  common_expenses: getP("common_expenses"),
                  water_list: data.transaction_payments || [],
                  water_list_price,
                  // ค่าต่อกลับมิเตอร์ของงวดเก่าถูกนับรวมอยู่ใน water_list_price (เข้ายอดค้างชำระ/รวมทั้งสิ้น) อยู่แล้ว
                  // บรรทัดนี้เป็นตัวเลข "แสดงผล" เท่านั้น (ผู้ใช้ยืนยันแล้วว่าไม่เอาไปคำนวณซ้ำ) โดยรวมค่าต่อกลับมิเตอร์
                  // ของงวดปัจจุบัน + ของทุกงวดค้างชำระที่ถูกจ่ายในใบเสร็จนี้ (นับเฉพาะงวดที่ s_meter_connect_cost = true)
                  // ห้ามนำ meter_connect_cost ตัวนี้ไปรวมใน total_calc/water_list_price ซ้ำ เพราะจะทำให้บรรทัดย่อยรวมเกินยอดจริง
                  meter_connect_cost:
                    getP("meter_connect_cost") +
                    total(
                      data.transaction_payments
                        .filter((e, i) => i !== 0)
                        .filter((e) => e.s_meter_connect_cost),
                      "meter_connect_cost"
                    ),
                  total_cost_late: getP("late_payment"),
                  fire_cost: getP("fire_cost"),
                  cable_cost: getP("cable_cost"),
                  other_income: getP("other_income"),
                  add_debt: getP("add_debt"),
                  add_on_add_debt: data.add_on_add_debt,
                  reduce_debt: getP("reduce_debt"),
                  add_on_reduce_debt: data.add_on_reduce_debt,
                  total: total_calc,
                  change_satang: data.change_satang,
                };
        
                console.log("data_print:", data_print);
        
                localStorage.setItem("DATA_", JSON.stringify(data_print));
                window.open("/doc/receipt", "_blank");
              }
            } else {
              alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
              this.clear_form();
            }
          }catch(e){
            console.log(e);
            alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
          }
          loading(false);
    };

  // CREATE — กันกดซ้ำด้วย flag บน instance (setState ยังไม่ทันอัปเดตตอนกดรัว) และรีเซ็ตปุ่มทุกทางด้วย finally
  Create = async () => {
    if (this._creating) return;
    this._creating = true;
    try {
      await this._create();
    } finally {
      this._creating = false;
      loading(false);
      this.setState({ disable_button: false });
    }
  };

  _create = async () => {
    const {
      payment_list,
      record_water_list,
      total_final,
      change_satang,
      add_on_add_debt,
      add_on_reduce_debt,
      add_on_add_debt_remark,
      add_on_reduce_debt_remark,
      total_pay,
      record_date,
      project_name,
      transfer_date,
      transfer_time,
      photo,
      address_number,
    } = this.state;
    let _record_water_list = [...record_water_list].sort(
      (a, b) => new Date(b.datetime_create) - new Date(a.datetime_create),
    );
    const finalAmount =
      Number(total_final) +
      Number(change_satang) +
      Number(add_on_add_debt) -
      Number(add_on_reduce_debt);

    if (Number(total_pay) - finalAmount < 0 || finalAmount < 0) {
      alert(
        "warning",
        "แจ้งเตือน",
        finalAmount < 0
          ? "ยอดชำระไม่สามารถน้อยกว่า 0 ได้"
          : "จำนวนเงินที่รับน้อยกว่ายอดชำระ",
      );
    }

    loading(true);
    this.setState({ disable_button: true });

    // ใช้เลขที่ได้จากการขอใหม่ตรงๆ ถ้าขอไม่ได้ค่อยใช้เลขเดิมใน state
    const sent_iw_number = (await this.GetRunningNumber()) || this.state.iw_number;
    let _payment_list = payment_list.map((p) => ({
      ...p,
      cost: p.title === "reduce_debt" && p.cost < 0 ? p.cost * -1 : p.cost,
      status_pay: p.cost !== 0 && p.status_pay,
    }));

    const transaction_payments = _record_water_list
      .filter((e) => e.status)
      .map((item) => {
        let updatedItem = { ...item };
        _payment_list.forEach(
          (p) =>
            (updatedItem[`s_${p.title}`] =
              p.status_pay && (!isSettled(item, `s_${p.title}`) && !item.payment_list?.find(pl => pl.title === p.title)?.status_pay) ? true : false),
        );
        return updatedItem;
      });

    let data = {
      ...this.state,
      iw_number: sent_iw_number,
      record_date: new Date(record_date).toISOString().split("T")[0],
      project_name: project_name,
      agency_name: project_name,
      transfer_date: transfer_date || null,
      transfer_time: transfer_time || null,
      record_water_list: _record_water_list
        .filter((item) => item.status)
        .map((item) => item.record_water_id),
      total_final: finalAmount,
      change_satang: Number(change_satang),
      add_on_add_debt: Number(add_on_add_debt),
      add_on_reduce_debt: Number(add_on_reduce_debt),
      add_on_add_debt_remark: add_on_add_debt_remark,
      add_on_reduce_debt_remark: add_on_reduce_debt_remark,
      photo: photo || "",
      transaction_payments,
      payment_list: _payment_list,
    };
    console.log("data: ", data);
    let result = await POST(
      tokens,
      "v1/TH/record-receipt/create/" + getStorage("project_id"),
      data,
    );
    if (result?.status) {
      const iw_number = this.pickIwNumber(result, sent_iw_number);
      alert_url(
        "success",
        "สำเร็จ",
        `บันทึกใบแจ้งหนี้หมายเลข "${iw_number}" สำเร็จแล้ว`,
        "/record-receipt",
      );
      await Promise.all([
        this.GetSetting(),
        calculate_water(address_number || ""),
        this.Print(iw_number),
        this.GetRunningNumber(),
      ]);
      if (this.props.location.query.address_number)
        await this.GetByAddressNumber(this.props.location.query.address_number);
    }
  };

  updatePermission = async () => {
    loading(true);
    let result = await POST(tokens, "v1/TH/record-receipt/check-box-confirm", {
      username: this.state.username,
      password: this.state.password,
    });
    if (result?.status)
      this.setState({ editable: true, modal_permission: false });
    loading(false);
    this.setState({ username: "", password: "" });
  };

  calTotalAmount = () => {
    const totalCost = Number(
      total(
        this.state.payment_list.filter((item) => item.status_pay),
        "cost",
      ).toFixed(2),
    );
    this.setState({ total_amount: totalCost, total_final: totalCost });
  };

  handlePaymentCheckboxChange = (index) => {
    let payment_list = [...this.state.payment_list];
    payment_list[index].status_pay = !payment_list[index].status_pay;
    this.setState({ payment_list }, () =>
      this.calTotalAmount(),
    );
  };

  handleAllPaymentCheckboxChange = (e) => {
    this.setState(
      {
        payment_list: this.state.payment_list.map((p) => ({
          ...p,
          status_pay: e.target.checked,
        })),
      },
      () => this.calTotalAmount(),
    );
  };

  handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const resizedPhotos = [];
    files.forEach((file) => {
      Resizer.imageFileResizer(
        file,
        720,
        720,
        "JPG",
        100,
        0,
        (uri) => {
          resizedPhotos.push(uri.split(",")[1]);
          if (resizedPhotos.length === files.length)
            this.setState({ photo: resizedPhotos });
        },
        "base64",
      );
    });
  };

  clear_form = () =>
    this.setState({
      modal_pay: false,
      modal_clement: false,
      modal_some_pay: false,
      editable: false,
      page: 1,
      search: "",
      username: "",
      password: "",
      address_text: "",
      customer_id: "",
      record_water_list: [],
      record_water_list_change: [],
      record_date: new Date(),
      record_time: format_date(new Date(),"hh:mm"),
      payment_type: 1,
      transfer_date: "",
      transfer_time: "",
      full_name: "",
      project_name: "",
      address: "",
      sum_unit_used: 0,
      payment_list: JSON.parse(JSON.stringify(INITIAL_PAYMENT_LIST)),
      record_other_list: [],
      clement_remark: "",
      total_amount: 0.0,
      change_satang: 0.0,
      total_final: 0.0,
      add_on_add_debt: 0,
      add_on_reduce_debt: 0,
      add_on_add_debt_remark: "",
      add_on_reduce_debt_remark: "",
      total_pay: 0.0,
    });

  render() {
    const {
      loading,
      iw_number,
      modal_permission,
      modal_some_pay,
      modal_pay,
      editable,
      data_customer,
      address_number,
      record_date,
      record_time,
      payment_type,
      transfer_date,
      transfer_time,
      full_name,
      project_name,
      address,
      payment_list,
      record_water_list,
      sum_unit_used,
      total_amount,
      total_final,
      change_satang,
      add_on_add_debt,
      add_on_reduce_debt,
      add_on_add_debt_remark,
      add_on_reduce_debt_remark,
      total_pay,
      username,
      password,
      record_water_list_change,
      ref_customer_id,
    } = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        {loading && (
          <div className="spinner-container">
            <div className="loading-spinner"></div>
          </div>
        )}
        <Navbar
          page1="หน้าหลัก"
          page2="ข้อมูลจัดเก็บค่าใช้จ่าย"
          page3="รับชำระค่าใช้จ่าย"
        />

        <div className="body">
          <div className="p-3">
            <div className="d-flex row mx-0 align-items-center justify-content-between">
              <h4 className="mb-3">
                <b>รับชำระค่าใช้จ่าย เลขที่ใบแจ้งหนี้ : {iw_number || "-"}</b>
              </h4>
              <div className="d-flex row mx-0">
                {create_r && (
                  <button
                    className="btn btn-outline-primary px-4 mx-1 mb-3"
                    onClick={() => this.setState({ modal_permission: true })}
                  >
                    แก้ไข
                  </button>
                )}
                {create_r && (
                  <button
                    className="btn btn-outline-primary px-4 mx-1 mb-3"
                    onClick={() =>
                      this.setState({
                        modal_some_pay: true,
                        record_water_list_change: record_water_list.map(
                          (e) => ({ ...e, checked: e.status }),
                        ),
                      })
                    }
                  >
                    ชำระบางส่วน
                  </button>
                )}
                <button
                  className="btn btn-outline-primary px-4 mx-1 mb-3"
                  onClick={() => {
                    window.location.href = "/billing";
                  }}
                >
                  ย้อนกลับ
                </button>
              </div>
            </div>

            <div className="card border-0 px-3 pt-3 mb-3">
              <div className="row">
                <div className="col-12 col-lg-4 col-xl-3">
                  <label>บ้านเลขที่</label>
                  <Select
                    className="form-control bg-contain border-0 select-search w-100 mb-3"
                    styles={select_style}
                    options={data_customer || []}
                    onChange={(e) => this.GetByAddressNumber(e.value)}
                    value={
                      data_customer?.find(
                        (item) => item.value === address_number,
                      ) || null
                    }
                  />
                </div>
                <div className="col-6 col-lg-4 col-xl-3 mb-3">
                  <label>วันที่</label>
                  <DatePicker
                    className="form-control bg-contain border-0"
                    value={record_date}
                    disabled
                  />
                </div>
                <div className="col-6 col-lg-4 col-xl-3 mb-3">
                  <label>เวลา</label>
                  <input
                    type="time"
                    className="form-control w-100 bg-contain border-0"
                    value={record_time}
                    disabled
                  />
                </div>

                <div className="col-12 col-lg-4 col-xl-3 mb-2">
                  <label>เลือกวิธีการชำระ</label>
                  <div className="d-flex" style={{ height: 60 }}>
                    <div className="d-flex wpx-100 align-items-center">
                      <input
                        type="radio"
                        checked={payment_type === 1}
                        onChange={(e) =>
                          e.target.checked &&
                          this.setState({
                            payment_type: 1,
                            transfer_date: "",
                            transfer_time: "",
                          })
                        }
                      />
                      <label className="mb-0 ml-3">เงินสด</label>
                    </div>
                    <div className="d-flex wpx-100 align-items-center">
                      <input
                        type="radio"
                        checked={payment_type === 2}
                        onChange={(e) =>
                          e.target.checked &&
                          this.setState({
                            payment_type: 2,
                            transfer_date: "",
                            transfer_time: "",
                          })
                        }
                      />
                      <label className="mb-0 ml-3">เงินโอน</label>
                    </div>
                  </div>
                </div>

                {payment_type === 2 && (
                  <>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3">
                      <label>วันที่โอน</label>
                      <DatePicker
                        className="form-control bg-contain border-0"
                        onChange={(e) => this.setState({ transfer_date: e })}
                        value={transfer_date}
                      />
                    </div>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3">
                      <label>เวลาโอน</label>
                      <input
                        type="time"
                        className="form-control w-100 bg-contain border-0"
                        onChange={(e) =>
                          this.setState({ transfer_time: e.target.value })
                        }
                        value={transfer_time}
                      />
                    </div>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3">
                      <label>รูปสลิปโอนเงิน</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="d-block w-100 border-0 pt-2 pb-0 px-2"
                        style={{ appearance: "none", background: "none" }}
                        multiple
                        onChange={this.handleImageUpload}
                      />
                    </div>
                  </>
                )}

                <div className="col-12 col-md-4 mb-3">
                  <label>ชื่อ-นามสกุล</label>
                  <input
                    type="text"
                    className="form-control w-100 bg-contain border-0"
                    onChange={(e) =>
                      this.setState({ full_name: e.target.value })
                    }
                    value={full_name}
                    disabled
                  />
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <label>ชื่อหน่วยงาน</label>
                  <input
                    type="text"
                    className="form-control w-100 bg-contain border-0"
                    onChange={(e) =>
                      this.setState({ project_name: e.target.value })
                    }
                    value={project_name}
                    disabled
                  />
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <label>ที่อยู่</label>
                  <input
                    type="text"
                    className="form-control w-100 bg-contain border-0"
                    onChange={(e) => this.setState({ address: e.target.value })}
                    value={address}
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="card border-0 p-3 mb-3">
              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      <th className="text-center wpx-100">
                        <input
                          type="checkbox"
                          className="mr-2"
                          checked={
                            payment_list.every((item) => item.status_pay) &&
                            payment_list.length > 0
                          }
                          onChange={this.handleAllPaymentCheckboxChange}
                          disabled={!editable}
                        />
                        เลือก
                      </th>
                      <th className="text-center wpx-100">ลำดับที่</th>
                      <th className="text-center">รายการ</th>
                      <th className="text-center">ข้อมูลเพิ่มเติม</th>
                      <th className="text-right">ราคารวมสุทธิ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payment_list.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <input
                            type="checkbox"
                            checked={item.status_pay}
                            onChange={() =>
                              this.handlePaymentCheckboxChange(index)
                            }
                            disabled={!editable}
                          />
                        </td>
                        <td className="text-center">{NumberZero(index + 1)}</td>
                        <td>{PAYMENT_TITLES[item.title]}</td>
                        <td>
                          {item.title === "water_bill" && (
                            <div className="d-flex justify-content-between">
                              {record_water_list.filter((w) => w.status)
                                .length > 1 && (
                                <label>
                                  จำนวนงวด{" "}
                                  {record_water_list.filter((w) => w.status)
                                    .length - 1}{" "}
                                  งวด
                                </label>
                              )}
                              <label></label>
                              <label>จำนวนหน่วยใช้ {sum_unit_used}</label>
                            </div>
                          )}
                        </td>
                        <td className="text-right">{toFixed(item.cost)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card border-0 p-3 mb-3">
              <div className="w-100 d-flex justify-content-between">
                <b>จัดเก็บเงินทั้งสิ้น</b> <b>฿{toFixed(total_amount)}</b>
              </div>
            </div>

            {create_r && (
              <button
                className="btn btn-outline-primary bg-white w-100 mb-4"
                onClick={() => {
                  if (total_amount === 0)
                    return alert(
                      "warning",
                      "แจ้งเตือน",
                      "กรุณาเลือกชำระอย่างน้อย 1 รายการ",
                    );
                  let valid = [
                    "customer_id",
                    "record_water_list",
                    "record_date",
                    "record_time",
                    "iw_number",
                    "payment_type",
                    "full_name",
                    "project_name",
                    "address",
                    "sum_unit_used",
                    "payment_list",
                    "total_amount",
                    "total_final",
                  ];
                  if (payment_type === 2) {
                    valid.push("transfer_date", "transfer_time");
                    if (this.state.is_upload_slip && !this.state.photo.length)
                      return alert(
                        "warning",
                        "แจ้งเตือน",
                        "กรุณาอัพโหลดสลิปการโอนเงิน",
                      );
                  }
                  if (validate(this.state, valid)) return;

                  let calcChangeSatang = 0;
                  if (payment_type === 1) {
                    let remainder = total_final % 0.25;
                    let roundedNumber =
                      total_final -
                      remainder +
                      (remainder > 0 && remainder < 0.25
                        ? 0.25
                        : remainder >= 0.25 && remainder < 0.5
                        ? 0.5
                        : remainder >= 0.5 && remainder < 0.75
                        ? 0.75
                        : remainder >= 0.75
                        ? 1
                        : 0);
                    calcChangeSatang = Number(
                      (roundedNumber - total_final).toFixed(2),
                    );
                  }

                  this.setState({
                    modal_pay: true,
                    total_pay:
                      payment_type === 2
                        ? Number(total_final)
                        : Number(total_final) + calcChangeSatang,
                    change_satang: calcChangeSatang,
                  });
                }}
              >
                พิมพ์ใบเสร็จ
              </button>
            )}
          </div>
        </div>

        {/* MODALS */}
        <Modal
          show={modal_some_pay}
          onHide={() =>
            this.setState({
              modal_some_pay: false,
              record_water_list_change: [],
            })
          }
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>
              <b>ชำระบางส่วน</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-borderless table-striped">
              <thead>
                <tr className="bg-dark-blue text-white">
                  <th className="text-center wpx-100">ลำดับที่</th>
                  <th className="text-center">ชื่อ-สกุล</th>
                  <th className="text-center">รายการค้างชำระรายเดือน</th>
                  <th className="text-center">ยอดเงินค้างชำระ</th>
                  <th className="text-center wpx-100">เลือก</th>
                </tr>
              </thead>
              <tbody>
                {record_water_list_change.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center wpx-100">
                      {NumberZero(index + 1)}
                    </td>
                    <td className="text-center">{item.full_name}</td>
                    <td className="text-center">
                      {format_date(item.datetime_create, "MMMM YYYY")}
                    </td>
                    <td className="text-center">
                      {toFixed(Number(item.total_amount))}
                    </td>
                    <td className="text-center wpx-100">
                      <input
                        type="checkbox"
                        className="mr-2"
                        checked={item.checked}
                        disabled={
                          ref_customer_id !== "" &&
                          ref_customer_id !== item.ref_customer_id
                        }
                        onChange={(e) => {
                          let rId = ref_customer_id || item.ref_customer_id;
                          if (rId === "" || rId === item.ref_customer_id) {
                            let list = [...record_water_list_change];
                            list.forEach((el, i) => {
                              if (
                                e.target.checked &&
                                i <= index &&
                                rId === el.ref_customer_id
                              )
                                el.checked = true;
                              else if (!e.target.checked && i > index)
                                el.checked = false;
                            });
                            list[index].checked = e.target.checked;
                            this.setState({
                              ref_customer_id: list.some((el) => el.checked)
                                ? item.ref_customer_id
                                : "",
                              record_water_list_change: list,
                            });
                          } else
                            alert(
                              "warning",
                              "แจ้งเตือน",
                              "ไม่สามารถเลือกบิลที่มีลูกหนี้ต่างกันกันได้",
                            );
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() =>
                    this.setState({
                      modal_some_pay: false,
                      record_water_list_change: [],
                    })
                  }
                >
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button
                  className="btn btn-primary w-100"
                  onClick={() => {
                    let list = record_water_list_change.map((e) => ({
                      ...e,
                      status: e.checked,
                    }));
                    if (!list.some((e) => e.status))
                      this.setState({ ref_customer_id: "" });
                    this.setState({ record_water_list_change: list }, () => {
                      setTimeout(() => {
                        let array = this.state.record_water_list_change.filter(
                          (item) => item.status,
                        );
                        if (!array.length)
                          return alert(
                            "warning",
                            "แจ้งเตือน",
                            "กรุณาเลือกอย่างน้อย 1 บิล",
                          );

                        let data = Object.keys(PAYMENT_TITLES).map((key) => {
                          const isLate = key === "late_payment";
                          const costKey = isLate ? "total_cost_late" : key;
                          const sKey = isLate ? "s_late_payment" : `s_${key}`;
                          return {
                            title: key,
                            status_pay: true,
                            cost:
                              total(
                                array.filter(
                                  (e) =>
                                    !isSettled(e, sKey) &&
                                    (!e.payment_list?.length ||
                                      e.payment_list.some(
                                        (p) => p.title === key && !p.status_pay,
                                      )),
                                ),
                                costKey,
                              ) * (key === "reduce_debt" ? -1 : 1),
                          };
                        });

                        this.setState({
                          modal_some_pay: false,
                          full_name:
                            list[
                              Math.max(
                                0,
                                list.findIndex((e) => e.checked),
                              )
                            ].full_name,
                          record_water_list: list,
                          record_water_list_change: [],
                          payment_list: data,
                          total_amount: Number(
                            total(array, "total_amount").toFixed(2),
                          ),
                          total_final: Number(
                            total(array, "total_amount").toFixed(2),
                          ),
                          sum_unit_used: Number(
                            total(array, "unit_used").toFixed(2),
                          ),
                        });
                      }, 100);
                    });
                  }}
                >
                  บันทึก
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={modal_pay}
          onHide={() => this.setState({ modal_pay: false })}
        >
          <Modal.Header>
            <Modal.Title>
              <b>ชำระเงิน</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">รับเงิน:</span>
              <button
                className="btn btn-outline-primary w-100 mr-3"
                onClick={() =>
                  this.setState({
                    total_pay:
                      Number(total_final) +
                      Number(change_satang) +
                      Number(add_on_add_debt) -
                      Number(add_on_reduce_debt),
                  })
                }
              >
                ชำระเต็มจำนวน
              </button>
              <input
                className="form-control border-0 bg-contain text-right"
                type="text"
                onChange={(e) =>
                  float(e.target.value) &&
                  this.setState({ total_pay: e.target.value || 0 })
                }
                value={total_pay}
                maxLength={11}
              />
              <span className="ml-3">บาท</span>
            </div>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 w-100">ยอดชำระ:</span>
              <b>{toFixed(Number(total_amount))}</b>
              <span className="ml-3">บาท</span>
            </div>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">ปรับเศษ:</span>
              <input
                className="form-control border-0 bg-contain text-right"
                type="text"
                onChange={(e) =>
                  float(e.target.value, 3) &&
                  this.setState({ change_satang: e.target.value || 0 })
                }
                value={change_satang}
                maxLength={5}
              />
              <span className="ml-3">บาท</span>
            </div>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">เพิ่มหนี้:</span>
              <input
                className="form-control border-0 bg-contain text-right"
                type="text"
                onChange={(e) =>
                  float(e.target.value, 3) &&
                  this.setState({ add_on_add_debt: e.target.value || 0 })
                }
                value={add_on_add_debt}
                maxLength={9}
              />
              <span className="ml-3">บาท</span>
            </div>
            {/* หมายเหตุเพิ่มหนี้ */}
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">หมายเหตุเพิ่มหนี้:</span>
              <input
                className="form-control border-0 bg-contain text-right"
                type="text"
                placeholder="กรอกข้อมูล"
                onChange={(e) => {
                  this.setState({
                    add_on_add_debt_remark: e.target.value,
                  });
                }}
                value={this.state.add_on_add_debt_remark}
              />
              <span className="ml-3">บาท</span>
            </div>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">ลดหนี้:</span>
              <input
                className="form-control border-0 bg-contain text-right"
                type="text"
                onChange={(e) =>
                  float(e.target.value, 3) &&
                  this.setState({ add_on_reduce_debt: e.target.value || 0 })
                }
                value={add_on_reduce_debt}
                maxLength={9}
              />
              <span className="ml-3">บาท</span>
            </div>
            
            {/* หมายเหตุลดหนี้ */}
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">หมายเหตุลดหนี้:</span>
              <input
                className="form-control border-0 bg-contain text-right"
                type="text"
                placeholder="กรอกข้อมูล"
                onChange={(e) => {
                  this.setState({
                    add_on_reduce_debt_remark: e.target.value,
                  });
                }}
                value={this.state.add_on_reduce_debt_remark}
              />
              <span className="ml-3">บาท</span>
            </div>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 w-100">จัดเก็บเงินทั้งสิ้น:</span>
              <b>
                {toFixed(
                  Number(total_final) +
                    Number(change_satang) +
                    Number(add_on_add_debt) -
                    Number(add_on_reduce_debt),
                )}
              </b>
              <span className="ml-3">บาท</span>
            </div>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 w-100">เงินทอน:</span>
              <b>
                {toFixed(
                  Number(total_pay) -
                    (Number(total_final) +
                      Number(change_satang) +
                      Number(add_on_add_debt) -
                      Number(add_on_reduce_debt)),
                )}
              </b>
              <span className="ml-3">บาท</span>
            </div>

            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() => this.setState({ modal_pay: false })}
                >
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button
                  className="btn btn-primary w-100"
                  onClick={this.Create}
                  disabled={this.state.disable_button}
                >
                  พิมพ์
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={modal_permission}
          onHide={() => this.setState({ modal_permission: false })}
        >
          <Modal.Header>
            <Modal.Title>
              <b>ขอสิทธิ์การแก้ไขข้อมูล</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-center mb-3">
              <label className="wpx-140">ชื่อผู้ใช้งาน{required}:</label>
              <input
                className="form-control border-0 bg-contain validate"
                type="text"
                onChange={(e) => this.setState({ username: e.target.value })}
                value={username}
              />
            </div>
            <div className="w-100 d-flex align-items-center mb-3">
              <label className="wpx-140">รหัสผ่าน{required}:</label>
              <input
                className="form-control border-0 bg-contain validate"
                type="password"
                onChange={(e) => this.setState({ password: e.target.value })}
                value={password}
              />
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() => this.setState({ modal_permission: false })}
                >
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button
                  className="btn btn-primary w-100"
                  onClick={this.updatePermission}
                >
                  ยืนยัน
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
